class PaymentOptions extends HTMLElement {
  constructor() {
    super();
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.transitionTimeout = null;
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('.method-item');
    this.footer = /** @type {HTMLElement} */ (this.querySelector('.payment-options-footer'));

    this.buttons.forEach(button =>
      button.addEventListener('click', this.handleButtonClick)
    );

    // Set first button (PIX) as active by default
    if (this.buttons.length > 0) {
      const firstButton = /** @type {HTMLElement} */ (this.buttons[0]);
      firstButton.click();
    }
  }

  /**
   * @param {MouseEvent} event
   */
  handleButtonClick(event) {
    const button = /** @type {HTMLElement} */ (event.currentTarget);
    const targetId = button.getAttribute('data-target');
    
    if (!targetId || !this.footer) return;
    const footer = this.footer;

    const template = this.querySelector(`#${targetId}`);
    if (!template) return;

    if (button.classList.contains('active')) return;

    if (this.transitionTimeout) {
      clearTimeout(this.transitionTimeout);
    }

    // Update active state
    this.buttons && this.buttons.forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');

    // Lock height and fade out
    const currentHeight = footer.offsetHeight;
    footer.style.height = `${currentHeight}px`;
    footer.style.overflow = 'hidden';
    footer.classList.add('is-hidden');
    
    this.transitionTimeout = setTimeout(() => {
      // Update content
      footer.innerHTML = template.innerHTML;

      // Measure new height
      footer.style.height = 'auto';
      const newHeight = footer.offsetHeight;

      // Reset to old height to animate
      footer.style.height = `${currentHeight}px`;
      // Force reflow
      footer.offsetHeight;

      // Animate to new height and fade in
      footer.style.height = `${newHeight}px`;
      footer.classList.remove('is-hidden');
      
      // Cleanup
      this.transitionTimeout = setTimeout(() => {
        footer.style.height = '';
        footer.style.overflow = '';
        this.transitionTimeout = null;
      }, 200);
    }, 200);
  }
}

customElements.define('payment-options', PaymentOptions);
